const apiBase = {
  add:'/api/app/add',//创建应用
  edit:'/api/app/edit',//重新申请
  queryPage:'/api/app/queryPage',//应用列表
  queryList:'/api/app/queryList',//应用列表-面包屑
  queryDetail:'/api/app/queryDetail',//应用详情
  queryLinkPage:'/api/appLink/queryPage',//链接列表
  addLink:'/api/appLink/add',//添加链接
  queryDefaultApkUrl:'/api/appLink/queryDefaultApkUrl',//查询默认兜底页
  queryLinkDetail:'/api/appLink/queryDetail',//链接详情
  queryModifyPage:'/api/appLink/queryModifyPage',//链接修改列表
  editReviewStateCancel:'/api/appLink/editReviewStateCancel',//撤回链接审核
  editStateDisable:'/api/appLink/editStateDisable',//关闭链接
  editStateEnable:'/api/appLink/editStateEnable',//开启链接
  queryModifyDetail:'/api/appLink/queryModifyDetail',//修改链接详情
  editParams:'/api/appLink/editParams',//修改链接参数
  queryAccessData:'/api/appLink/queryAccessData',//链接访问数据折线图
  queryAccessDataList:'/api/appLink/queryAccessDataList',//链接访问列表
  exportAccessDataList:'/api/appLink/exportAccessDataList',//链接访问导出
  queryAppLinkLinkDistributionData: '/api/appLink/queryLinkDistributionData',//链接分发折线图
  exportAppLinkLinkDistributionData: '/api/appLink/exportLinkDistributionData',//链接分发导出
  queryFreezeReason:'/api/appLink/queryFreezeReason',//冻结原因
  queryData:'/api/app/queryData',//应用数据概况
  queryAppLinkTop:'/api/app/queryAppLinkTop',//应用单链接访问分布饼图
  queryAppLinkTopList:'/api/app/queryAppLinkTopList',//应用单链接访问分布明细列表
  queryLinkAccessData:'/api/app/queryLinkAccessData',//应用链接访问数据折线图
  queryAppLinkAccessDataList:'/api/app/queryLinkAccessDataList',//应用链接访问数据-列表
  exportLinkAccessDataList:'/api/app/exportLinkAccessDataList',//应用链接访问数据-列表导出
  queryLinkDistributionData:'/api/app/queryLinkDistributionData',//应用链接分发数据折线图
  exportLinkDistributionData:'/api/app/exportLinkDistributionData',//应用链接分发数据导出
  qrcode:'/api/appLink/qrcode',//二维码下载
}
let ConsoleSeverObject = null
class ConsoleSever {
  constructor() {}
  queryDetail(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryDetail,
      data: params
    })
  }

  queryLinkDistributionData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryLinkDistributionData,
      data: params
    })
  }
  
  qrcode(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.qrcode,
      data: params
    })
  }


  queryAppLinkLinkDistributionData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAppLinkLinkDistributionData,
      data: params
    })
  }

  exportAppLinkLinkDistributionData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportAppLinkLinkDistributionData,
      data: params
    })
  }

  exportLinkDistributionData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportLinkDistributionData,
      data: params
    })
  }

  queryData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryData,
      data: params
    })
  }

  queryAppLinkTop(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAppLinkTop,
      data: params
    })
  }

  queryAppLinkTopList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAppLinkTopList,
      data: params
    })
  }

  queryLinkAccessData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryLinkAccessData,
      data: params
    })
  }

  queryAppLinkAccessDataList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAppLinkAccessDataList,
      data: params
    })
  }

  exportLinkAccessDataList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportLinkAccessDataList,
      data: params
    })
  }

  add(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.add,
      data: params
    })
  }

  edit(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.edit,
      data: params
    })
  }

  queryPage(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryPage,
      data: params
    })
  }
  queryList(params = {}){
    return $http({
      method: 'post',
      url: apiBase.queryList,
      data: params
    })
  }
  queryLinkPage(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryLinkPage,
      data: params
    })
  }
  addLink(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.addLink,
      data: params
    })
  }
  queryDefaultApkUrl(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryDefaultApkUrl,
      data: params
    })
  }
  
  queryLinkDetail(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryLinkDetail,
      data: params
    })
  }

  queryModifyPage(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryModifyPage,
      data: params
    })
  }

  editReviewStateCancel(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.editReviewStateCancel,
      data: params
    })
  }

  editStateDisable(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.editStateDisable,
      data: params
    })
  }

  editStateEnable(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.editStateEnable,
      data: params
    })
  }

  queryModifyDetail(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryModifyDetail,
      data: params
    })
  }

  editParams(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.editParams,
      data: params
    })
  }

  queryAccessData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAccessData,
      data: params
    })
  }
  queryAccessDataList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryAccessDataList,
      data: params
    })
  }
  exportAccessDataList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportAccessDataList,
      data: params
    })
  }
  queryDistributionData(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryDistributionData,
      data: params
    })
  }
  exportLinkAccessDataList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportLinkAccessDataList,
      data: params
    })
  }

  queryFreezeReason(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryFreezeReason,
      data: params
    })
  }
 
}

function singleConsoleSever() {
  if (ConsoleSeverObject === null) {
    ConsoleSeverObject = new ConsoleSever()
  }
  return ConsoleSeverObject
}
export default singleConsoleSever()
